import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

export const SpaceRoleManagementScreen: LoadableType<{
	spaceKey: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceRoleManagementPage" */ '../src/page/SpaceRoleManagementPage.tsx'
			)
		).SpaceRoleManagementPage,
	name: 'SpaceRoleManagementPage',
});
